<template>
  <b-container fluid>
    <div class="row mt-3">
      <b-col class="d-flex justify-content-start">
        <h4>Reporte de Stock Minimo</h4>
      </b-col>
    </div>
    <b-row class="stats text-center">
      <b-col cols="lg-12">
        <div class="stat">
          <div class="number"><span class="balance">{{minStockNumber}}</span></div>
          <div class="desc">PRODUCTOS DEBAJO DEL MINIMO DE STOCK</div>
        </div>
      </b-col>
    </b-row>
    <!-- Filtros y botones de exportación
    <div class="p-3 bg-light rounded-sm my-2 border">
      <div class="row d-flex justify-content-between">
        <div class="col col-md-2">
          <p class="d-flex justify-content-start">Filtros: </p>
          <b-form-select v-model="filters.active" class="p-2" aria-label="Filtros" @change="refreshTable()">
            <b-form-select-option :value="0" id="todos">Todos los productos</b-form-select-option>
            <b-form-select-option :value="1" id="activos" selected="selected">Productos activos</b-form-select-option>
            <b-form-select-option :value="2" id="inactivos">Productos Inactivos</b-form-select-option>
          </b-form-select>
        </div>
        <div class="col col-md-2">
          <label class="d-block mb-2 text-left">Exportar:</label>
            <button 
              class="btn btn-outline-primary mr-1" 
              type="button" 
              @click="exportCSV()"
            >
              Exportar CSV
            </button>
            <button 
              class="btn btn-outline-primary ml-1" 
              type="button" 
              @click="exportPDF()"
            >
              Exportar PDF
            </button>
        </div>
      </div>
    </div>
    -->
    <b-row>
      <b-col cols="md-12">
        <vdtnet-table
          :fields="fields"
          :opts="opts"
          :selectCheckbox="0"
          ref="table"
        />
      </b-col>
    </b-row>
  </b-container>

</template>

<script>
import VdtnetTable from "vue-datatables-net";

export default {
  components: {
    VdtnetTable,
  },
  data: function() {
    return {
      isLoading: false,
      minStockNumber: 0,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
          },
        ajax: {
          url: process.env.VUE_APP_BASE_URL+"/api/reports/stockmin",
          type: "GET",
          headers: { Authorization: "Bearer " + localStorage.getItem("token"),
          },
          data: (d) => {
            d.active = this.filters.active
          },        
        },
      },
      fields: {
        name: { label: "Nombre" },
        stock_minimum: { label: "Mínimo" },
        stock: { label: "Cantidad" },
        provname: { label: "Proveedor" },
        phone: { label: "Teléfono" },
        email: { label: "email" },
      },
      filters:{
        active:1,
      },
    };
  },
  mounted() {
    this.getMinStockReport();
  },
  methods: {
    refreshTable() {
      var vm = this;
      if (vm.$refs.table !== undefined) vm.$refs.table.reload();
    }, 
    getMinStockReport() {
      var vm = this;
      console.log(this.filters);
      vm.isLoading = true;
      this.$http.get(process.env.VUE_APP_BASE_URL+"/api/reports/stockmin_number", {params:this.filters}).then((response) => {
        vm.minStockNumber = response.data.data;
        console.log(vm.minStockNumber);
        vm.isLoading = false;
      });
    },
    exportCSV() {
        // no entiendo como lo hace en el blade

      /*let vm = this;
      vm.loading = true;
      axios
        .post("/api/reports/CSVpurchaseReport", this.filters)
        .then((response) => {
          console.log("response", response);
          if (response.data) {
            vm.loading = false;
            var filename = "Vision-general-de-compras.cvs";
            var blob = new Blob([response.data], {
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            vm.loading = false;
            
          }
        })
        .catch((error) => {
          vm.loading = false;
          alert(error);
        }); */
    },
    exportPDF() {
         // no entiendo como lo hace en el blade

        /*
      let vm = this;
      vm.loading = true;
      axios
        .post("/api/reports/PDFpurchaseReport", this.filters)
        .then((response) => {
          if (response.status == 200) {
            axios
              .get("/api/reports/PDFlistReport")
              .then((response) => {
                if (response.status == 200) {
                  vm.loading = false;
                  window.open("/api/reports/PDFlistReport", "_blank") ||
                    window.location.replace("/api/reports/PDFlistReport");
                } else {
                  vm.loading = false;
                  
                }
              })
              .catch((error) => {
                console.log("error: " + error);
              });
          } else {
            vm.loading = false;
            
          }
        })
        .catch((error) => {
          vm.loading = false;
          alert(error);
        }); */
    },
  },
  watch: {
    'filters.active': { handler: function (a) {
      this.getMinStockReport();
      this.refreshTable();
      }
    },
  },
};
</script>

<style scoped>
  .balance {
    font-weight: bold;
    font-size: 3rem;
  }
</style>
